import KendoAutoCompleteMixin from './KendoAutoCompleteMixin'

export default {
    name: 'kendo-autocomplete',
    mixins: [ KendoAutoCompleteMixin ]
}


// WEBPACK FOOTER //
// ./packages/kendo-dropdowns-vue-wrapper/src/KendoAutoComplete/index.js